import React, { Component, createRef } from 'react';
import gsap from "gsap";
import { URLImgFront } from '../../../config/URLDB';
import { hoverBoton, salidaBoton, focusBoton, blurBoton, animarContenido } from '../../../utils/Animaciones'

import { SegurosConfiguracion_ } from '../../../services/WebAPI_Utrahuilca';
import Swal from 'sweetalert2';

class Detalle_PlanExequial extends Component {
    constructor(props) {
        super(props);
        this.state = {
            opcion: 0,
            items: []
        };

        this.headerRef = createRef();
        this.botonesRef = createRef();
        this.contenidoRef = createRef();
    }

    async componentDidMount() {
        await this.DatosPlanExequial();

        if (!this.headerRef.current || !this.botonesRef.current || !this.contenidoRef.current) return;
        const lineaTiempo = gsap.timeline({ defaults: { ease: "power3.out" } });

        lineaTiempo.fromTo(
            this.headerRef.current,
            { opacity: 0, x: -60 },
            { opacity: 1, x: 0, duration: 0.7 }
        );

        const botones = this.botonesRef.current.querySelectorAll(".seguro-btn-detalle, .seguro-btn-regresar");

        if (botones.length > 0) {
            lineaTiempo.fromTo(
                botones,
                { opacity: 0, y: 30 },
                { opacity: 1, y: 0, duration: 0.5, stagger: 0.15 },
                "-=0.3"
            );
        }

        lineaTiempo.fromTo(
            this.contenidoRef.current,
            { opacity: 0, x: 50 },
            { opacity: 1, x: 0, duration: 0.6 },
            "-=0.2"
        );
    }

    DatosPlanExequial = async () => {
        const { id, titulo, description } = this.props;
        const data = {
            tran: 6,
            idconfigseguitem: 0,
            idseguro: id,
            idseguitem: 0,
            titulo: "NA",
            descripcion: "NA",
            rutaicono: "NA",
            idtipoenlace: 0,
            rutaconfig: "NA",
            orden: 0,
            estado: 1,
            idusucrea: 0,
            feccrea: null,
        };

        try {
            const planBase = {
                id: id,
                titulo: titulo || "",
                description: description || "",
                planes: [],
                bondades: [],
                coberturas: []
            };
            const response = await SegurosConfiguracion_(data);
            const cantregistros = response?.length ?? 0;
            if (cantregistros > 0 && !response[0]?.message) {
                response.forEach(item => {
                    switch (item.idseguitem) {
                        // PLANES
                        case 1:
                            planBase.planes.push({
                                titulo: item.titulo,
                                descripcion: item.descripcion,
                                img: `${URLImgFront}/assets/${item.rutaicono}`
                            });
                            break;
                        // BONDADES
                        case 2:
                            planBase.bondades.push({
                                titulo: item.titulo,
                                descripcion: item.descripcion,
                                imgitems: `${URLImgFront}/assets/${item.rutaicono}`
                            });
                            break;
                        // COBERTURA
                        case 3:
                            planBase.coberturas.push({
                                titulo: item.titulo,
                                descripcion: item.descripcion,
                                imgitems: `${URLImgFront}/assets/${item.rutaicono}`
                            });
                            break;
                        default:
                            break;
                    }
                });
            }
            this.setState({ items: [planBase] });
        } catch (error) {
            Swal.fire({
                icon: 'error',
                text: 'Ocurrió un error al consumir el servicio'
            });
        }
    };

    cambiarOpcion = (idopcion) => {
        if (idopcion !== this.state.opcion) {
            animarContenido(this.contenidoRef.current, (animar) => {
                this.setState({ opcion: idopcion }, animar);
            });
        }
    };

    render() {
        const plan = this.state.items.find(
            item => item.id === this.props.id
        );

        if (!plan) return null;
        let datosSeguro = []; let imgitems = ""; let titulo = "";

        if (this.state.opcion === 1) {
            datosSeguro = plan.bondades;
            imgitems = plan.bondades?.[0]?.imgitems || "";
            titulo = plan.bondades?.[0]?.titulo || "";
        }

        if (this.state.opcion === 2) {
            datosSeguro = plan.coberturas;
            imgitems = plan.coberturas?.[0]?.imgitems || "";
            titulo = plan.coberturas?.[0]?.titulo || "";
        }

        return (
            <React.Fragment>
                <div ref={this.headerRef} style={{ backgroundColor: '#EBFDFF' }} >
                    <div className="row align-items-center justify-content-center">
                        <div className="col-sm-auto py-4 justify-content-around d-flex">
                            <img src={this.props.ruta} className="seguro-card-detalle shadow" alt={plan.titulo} />
                        </div>
                        <div className="col-sm-6 py-4">
                            <h5 className="seguro-titulo">{plan.titulo}</h5>
                            <p className="seguro-texto-descrip">{plan.description}</p>
                        </div>
                    </div>
                </div>
                <div ref={this.botonesRef} className="row seguro-botones-container px-3 px-md-4 justify-content-center">
                    <div className="col-6 col-md-auto p-2 d-flex justify-content-center">
                        <button type="button" className="seguro-btn-detalle" onClick={() => this.cambiarOpcion(0)} onMouseEnter={hoverBoton} onMouseLeave={salidaBoton} onFocus={focusBoton("#37B3C1", "#ffffff")} onBlur={blurBoton("#ffffff", "#37B3C1")} autoFocus={true}>
                            PLANES
                        </button>
                    </div>
                    <div className="col-6 col-md-auto p-2 d-flex justify-content-center">
                        <button type="button" className="seguro-btn-detalle" onClick={() => this.cambiarOpcion(1)} onMouseEnter={hoverBoton} onMouseLeave={salidaBoton} onFocus={focusBoton("#37B3C1", "#ffffff")} onBlur={blurBoton("#ffffff", "#37B3C1")}>
                            BONDADES
                        </button>
                    </div>
                    <div className="col-6 col-md-auto p-2 d-flex justify-content-center">
                        <button type="button" className="seguro-btn-detalle" onClick={() => this.cambiarOpcion(2)} onMouseEnter={hoverBoton} onMouseLeave={salidaBoton} onFocus={focusBoton("#37B3C1", "#ffffff")} onBlur={blurBoton("#ffffff", "#37B3C1")}>
                            COBERTURAS
                        </button>
                    </div>
                    <div className="col-6 col-md-auto p-2 d-flex align-items-center justify-content-center mb-3">
                        <div className="seguro-btn-regresar" onMouseEnter={hoverBoton} onMouseLeave={salidaBoton} onClick={() => this.props.onAccion(1)}>
                            <img src={`${URLImgFront}/assets/Seguros/BtnRegresar.webp`} alt="clausula" className="seguro-img-regresar " />
                        </div>
                    </div>
                </div>
                <div ref={this.contenidoRef}>
                    {this.state.opcion === 0 && (
                        <>
                            {plan.planes.map((p, index) => {
                                const backgroundColor = index % 2 === 1 ? '#EBFDFF' : 'transparent';
                                const flexDirection = index % 2 === 1 ? 'row-reverse' : 'row';

                                return (
                                    <div key={index} style={{ padding: '30px', backgroundColor }}>
                                        <div className="row align-items-center justify-content-center" style={{ flexDirection }}>
                                            <div className="col-md-auto mb-3">
                                                <h5 className="mt-0" style={{ color: '#37B3C1', fontSize: '35px', fontWeight: 800 }}> {p.titulo} </h5>
                                                <img style={{ maxWidth: '75%', height:'auto' }} src={p.img} className="align-self-center mr-3" alt={p.titulo} />
                                            </div>
                                            <div className="col-md-8">
                                                <div className="text-left">
                                                    <p className="seguro-texto-descrip" style={{ marginBottom: "4px" }} dangerouslySetInnerHTML={{ __html: p.descripcion }} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </>
                    )}

                    {(this.state.opcion === 1 || this.state.opcion === 2) && (
                        <div className="row justify-content-center">
                            <div className="col-md-auto mb-4">
                                <img src={imgitems} className="align-self-center mr-3 seguro-icono" alt="info" />
                            </div>
                            <div className="col-md-auto" style={{ maxWidth: '75%' }}>
                                <div className="row align-items-center justify-content-center">
                                    <div className="col-md-auto seguro-texto-descrip text-left" >
                                        <h5 style={{ fontWeight: 700 }}>{titulo}</h5>
                                        {datosSeguro.map((item, i) => (
                                            <div key={i}>
                                                <p className="seguro-texto-descrip" style={{ marginBottom: "4px" }} dangerouslySetInnerHTML={{ __html: item.descripcion }} />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </React.Fragment>
        );
    }
}

export default Detalle_PlanExequial;